import React                       from "react";
import PropTypes                   from "prop-types";
import { inject, observer }        from 'mobx-react'
// import { Switch, Route, Redirect } from "react-router-dom";
import { Redirect } from "react-router-dom";
// import Cookies                     from 'universal-cookie';
import withStyles                  from "material-ui/styles/withStyles";


import FormControl    from "material-ui/Form/FormControl";
import InputLabel     from "material-ui/Input/InputLabel";
import Select         from "material-ui/Select/Select";
import MenuItem       from "material-ui/Menu/MenuItem";
import InputAdornment from "material-ui/Input/InputAdornment";
import Email          from "@material-ui/icons/Email";
import LockOutline    from "@material-ui/icons/LockOutline";

// core components
import GridContainer from "../../components/Grid/GridContainer";
import ItemGrid from "../../components/Grid/ItemGrid";
// import GridItem from "../../components/Grid/GridItem";
import LoginCard from "../../components/Cards/LoginCard.jsx";
import CustomInput from "../../components/CustomInput/CustomInput.jsx";
import Button from "../../components/CustomButtons/Button.jsx";
import Snackbar from "../../components/Snackbar/Snackbar.jsx";
import loginPageStyle from "../../assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";

import {PHOTOSELFIE_BASE_URL} from "../../utils/constants";
/*
import {
    MERCHANT_ROLE_ID
} from "../../utils/constants";
*/

import Muted from "../../components/Typography/Muted.jsx";
import Success from "../../components/Typography/Success";
// import {FormLabel} from "material-ui";


// import AlertWithConfirm from "../Components/AlertWithConfirm";
import {toJS} from "mobx";
// import CustomDropdown from "../../components/CustomDropdown/CustomDropdown";
import itFlag from "../../assets/img/flags/IT.png";
import gbFlag from "../../assets/img/flags/GB.png";
import frFlag from "../../assets/img/flags/FR.png";
import deFlag from "../../assets/img/flags/DE.png";
import esFlag from "../../assets/img/flags/ES.png";




// const cookies = new Cookies();

@inject('store')
@observer
class LoginPage extends React.Component {

    constructor(props) {
        
        super(props);
        // we use this to make the card to appear after the page has been rendered
        this.state = {
            cardAnimaton: "cardHidden",
            email: this.props.store.appState.email,
            password:'',
            submitted:false,
            validEmail:null,
            validPassword:null,
            goToDashboard: false,
            recoverPassword:true,
            redirect: this.props.store.appState.token && this.props.store.appState.user_has_permission_to_access_ps ? '/project' : false,
            open: true,
            tl: false,
            setTl: false,
            language: 'it',
            validLanguage:null,
            setSimpleSelect:"",
            setAlert:null,
        };

        this.setEmail = this.setEmail.bind(this);
        this.setPassword = this.setPassword.bind(this);
        this.setLanguage = this.setLanguage.bind(this);
        // this.handleLang = this.handleLang.bind(this);
        this.login = this.login.bind(this);
        this.recoverPassword = this.recoverPassword.bind(this);
        this.closeNotification = this.closeNotification(this);
        this.hideAlert = this.hideAlert.bind(this);

        this.store = this.props.store.appState;
    }

    componentDidMount() {
        // we add a hidden class to the card and after 700 ms we delete it and the transition appears
        setTimeout(
            function() {
                this.setState({ cardAnimaton: "" });
            }.bind(this),
            300
        );
        //console.log("A", this.store.user_has_permission_to_access_ps);
    }

    status(){
        this.setState({login: true});
    }


    login = (event) => {
        const min_len_password = 5;
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        
        if ( !re.test(this.state.email) ) {
            this.setState({validEmail:false});
        }

        if ( this.state.password.length<min_len_password ) {
            this.setState({validPassword:false});
        }

        if(re.test(this.state.email) && this.state.password.length>=min_len_password && this.state.language !== ""){
            this.setState({submitted:true});
            let self = this;

            //1- Verifica la correttezza di user e password
            //2- Recupero di tutti i permessi associati ai ruoli dell’utente
            //3- Se un utente non ha il permesso photoselfie::access non può accedere

            self.store.login(this.state.email,this.state.password, function(res){
                // console.log(res);
                if(res){
                    self.store.health_check(function(res) {
                        if (res) {
                            // console.log(res);
                            if(self.store.token){
                                // console.log("1");
                                // console.log(self.store.token);
                                self.store.me({permissions: 1}, function (res) {
                                    // console.log("2");
                                    // console.log(res);
                                    // console.log("USER PERMISSION: ", self.store.user_has_permission_to_access_ps);

                                    if (res && self.store.user_has_permission_to_access_ps) {
                                        self.setState({redirect:'/project'});

                                        // console.log("Role-Permissions", res.permissions);
                                        // Se un utente non ha il permesso photoselfie::access non può accedere

                                        // const user_has_permissions = res['permissions'].filter(obj => {
                                        //     return obj.name === 'photoselfie::access'
                                        // });

                                        // console.log("USER_PERMISSION", user_has_permissions);

                                        // if(user_has_permissions.length > 0){
                                        //     self.setState({redirect:'/project'});
                                        // }else{
                                        //     self.setState({setTl: true, tl: true});
                                        // }

                                        // res['permissions'].forEach(function (perm) {
                                        //
                                        //     if (perm.name === 'photoselfie::access') {
                                        //         self.permitted_users = true;
                                        //         self.store.permitted_users = true;
                                        //         self.setState({loading: false});
                                        //     }
                                        //
                                        //     if(perm.name.toLowerCase().startsWith('photoselfie')){
                                        //
                                        //
                                        //         let slug = perm.name.split('::').pop();
                                        //
                                        //         if(slug === 'shop'){
                                        //             let item = '/ordini-shop';
                                        //             menu_items_allowed.push(item);
                                        //             self.permitted_users_shop = true;
                                        //             self.store.permitted_users_shop = true;
                                        //         }
                                        //
                                        //         if(slug === 'myshop'){
                                        //             let item = '/ordini-myshop';
                                        //             let item_1 = '/myshop';
                                        //             menu_items_allowed.push(item);
                                        //             menu_items_allowed.push(item_1);
                                        //             self.permitted_users_myshop = true;
                                        //             self.store.permitted_users_myshop = true;
                                        //         }
                                        //
                                        //         if(slug === 'stack'){
                                        //             let item = '/margini-royalties';
                                        //             menu_items_allowed.push(item);
                                        //             self.permitted_users_stack = true;
                                        //             self.store.permitted_users_stack = true;
                                        //         }
                                        //
                                        //         if(slug === 'coupon'){
                                        //             let item = '/coupon';
                                        //             menu_items_allowed.push(item);
                                        //             self.permitted_users_coupon = true;
                                        //             self.store.permitted_users_coupon = true;
                                        //         }
                                        //     }
                                        // });

                                    } else {
                                        // console.log(res);
                                        self.setState({setTl: true, tl: true});
                                    }
                                }, true);
                            }else{
                                self.setState({loading: false, maintenance_mode: false, alert: true});
                            }
                        } else {
                            self.setState({maintenance_mode:false, loading:false, alert: true});
                        }
                    });

                    // let roles = res.roles.split(',').map(Number);
                    // {
                    //     roles.includes(MERCHANT_ROLE_ID)
                    //         ?
                    //         copythis.setState({redirect:'/project'})
                    //         :
                    //
                    //         copythis.setState({setTl: true, tl: true})
                    //     // alert("L'utente non ha il Ruolo giusto per accedere!!!");
                    // }
                }else{
                    self.setState({submitted:false, validEmail:false, validPassword:false, recoverPassword:true});
                }
            });
        }
        event.preventDefault();
    }

    setEmail(event) {
        this.setState({email: event.target.value, validEmail:null});
    }

    setPassword(event) {
        this.setState({password: event.target.value, validPassword:null});
    }

    setLanguage(event){
        
        // this.setState({language: event.target.value, validLanguage:null});

        this.setState({language: event.target.value});
        this.store.handle_app_lang(event.target.value);

        const lang = event.target.value;

        // const DEFAULT_TEXT = import(`../../assets/translations/${lang}`).then((lang) => {
        import(`../../assets/translations/${lang}`).then((lang) => {
            this.setState({
                text: lang
            })
        }).catch((error) => {
            // console.error(`"${this.state.language}" not yet supported`);
        });
    };

    hideAlert(){
        this.setState({setTl:false, submitted:false, recoverPassword:true});
    }

    recoverPassword(event){
        const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT);
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if ( !re.test(this.state.email) ) {
            this.setState({validEmail:false});
        }

        if(re.test(this.state.email)) {
            this.setState({submitted:true});
            let self = this;
            this.store.recover_password(self.state.email, function(res){
                self.setState({message:DEFAULT_TEXT.RECOVER_PASSWORD, submitted:false, recoverPassword:true});
            });

        }
    }

    closeNotification(){
        this.setState({open: false})
    }

    _handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.login(e);
        }
    };

    render() {
        if(this.state.redirect){
            return <Redirect to={this.state.redirect} />
        }
        const { classes } = this.props;
        const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT);
        return (
            <div className={classes.content}>
                <div className={classes.container}>
                    <GridContainer justify="center">
                        <ItemGrid xs={12} sm={6} md={4}>
                            <form>
                                <LoginCard
                                    customCardClass={classes[this.state.cardAnimaton]}
                                    headerColor="rose"
                                    cardTitle={DEFAULT_TEXT.login_title}
                                    cardSubtitle=""
                                    footerAlign="center"
                                    footer={
                                        <Button color="roseNoBackground" wd size="lg" onClick={this.login} disabled={this.state.submitted ? true : false}>
                                            {DEFAULT_TEXT.login_button ? DEFAULT_TEXT.login_button : "" }
                                        </Button>
                                    }
                                    socials={[
                                        // "fab fa-facebook-square",
                                        // "fab fa-twitter",
                                        // "fab fa-google-plus"
                                    ].map((prop, key) => {
                                        return (
                                            <Button
                                                color="simple"
                                                justIcon
                                                key={key}
                                                customClass={classes.customButtonClass}
                                            >
                                                <i className={prop} />
                                            </Button>
                                        );
                                    })}
                                    content={
                                        <div>
                                            <CustomInput
                                                labelText={DEFAULT_TEXT.login_form_1}
                                                id="email"
                                                error={this.state.validEmail===false ? true : false}
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    onKeyPress:this._handleKeyPress,
                                                    value:this.state.email,
                                                    'type':'text',
                                                    "onChange":this.setEmail,
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <Email className={classes.inputAdornmentIcon} />
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />

                                            <CustomInput
                                                labelText={DEFAULT_TEXT.login_form_2}
                                                id="password"
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                error={this.state.validPassword===false ? true : false}
                                                inputProps={{
                                                    onKeyPress:this._handleKeyPress,
                                                    value:this.state.password,
                                                    'type':'password',
                                                    "onChange":this.setPassword,
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <LockOutline className={classes.inputAdornmentIcon} />
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                            <FormControl fullWidth className={classes.selectFormControl}>
                                                {
                                                    this.state.language === "" ?
                                                        <InputLabel > Seleziona la lingua </InputLabel>
                                                        : <p/>
                                                }

                                                <Select
                                                    // MenuProps={{ className: classes.selectMenu }}
                                                    // classes={{ select: classes.select }}
                                                    className={classes.selectFormControl}
                                                    value={this.state.language}
                                                    error={this.state.validLanguage===false ? true : false}
                                                    // onChange={() =>{this.setLanguage("1")}}
                                                    onChange={this.setLanguage}
                                                    inputProps={{ name: "simpleSelect", id: "simple-select" }}

                                                >
                                                    {/*<MenuItem disabled classes={{ root: classes.selectMenuItem }} > Single Select </MenuItem>*/}
                                                <MenuItem
                                                    // classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}}
                                                    value="it" ><span><img src={itFlag} alt="..."/> Italiano </span></MenuItem>
                                                <MenuItem
                                                    // classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}}
                                                    value="en" ><span><img src={gbFlag} alt="..."/> English </span></MenuItem>
                                                <MenuItem
                                                    // classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}}
                                                    value="fr" ><span><img src={frFlag} alt="..."/> Français</span></MenuItem>
                                                <MenuItem
                                                    // classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}}
                                                    value="de" ><span><img src={deFlag} alt="..."/> Deutsch</span></MenuItem>
                                                <MenuItem
                                                    // classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}}
                                                    value="es" ><span><img src={esFlag} alt="..."/> Español</span></MenuItem>
                                                </Select>
                                            </FormControl>

                                            {
                                                !this.state.message
                                                    ?
                                                    <div style={{display:'flex', justifyContent:"flex-end",paddingTop: "25px"}}>
                                                        <a href={PHOTOSELFIE_BASE_URL} onClick={this.recoverPassword}><Muted>{DEFAULT_TEXT.login_action_1}</Muted></a>
                                                    </div>
                                                    : null
                                            }

                                            {
                                                this.state.message && this.state.recoverPassword
                                                    ?
                                                    <div style={{display:'flex', justifyContent:"center"}}>
                                                        <Success>{this.state.message}</Success>
                                                    </div>
                                                    : null
                                            }


                                            {
                                                this.state.setTl
                                                    ?
                                                        <Snackbar
                                                            place="bc"
                                                            color="warning"
                                                            message={DEFAULT_TEXT.login_alert}
                                                            open={this.state.tl}
                                                            closeNotification={() => this.hideAlert()}
                                                            close
                                                            // autoHideDuration={3000}
                                                            />
                                                    : null
                                            }
                                        </div>
                                    }
                                >
                                </LoginCard>
                            </form>
                        </ItemGrid>
                    </GridContainer>
                </div>
            </div>
        );
    }
}

LoginPage.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(loginPageStyle)(LoginPage);





// WEBPACK FOOTER //
// ./src/views/Login/Login.jsx